import makeList from "./list.vue";
let a = Object.assign({makeList})
export default a;
